/* eslint-disable no-undef */
<template>
<v-container grid-list-xl fill-height>
  <v-layout row fill-height align-center justify-center>
    <v-flex xl3 lg3 md4 sm4 xs8>
      <v-card>
        <v-card-text>
          <v-layout row justify-center align-center>
            <v-flex xs6>
              <img height="50px" src="@/assets/aclogoAlterna-Logo@3x.png"/>
            </v-flex>
          </v-layout>
          <v-container>
            <form>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    label="Username"
                    v-validate="'required'"
                    data-vv-name="username"
                    :error-messages="errors.collect('username')"
                    v-model="username"
                    required
                    flat
                    prepend-inner-icon="person"
                    @keyup.enter="validateBeforeSubmit(submit)"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    label="Password"
                    v-validate="'required|min:4'"
                    data-vv-name="password"
                    :error-messages="errors.collect('password')"
                    type="password"
                    v-model="password"
                    flat
                    prepend-inner-icon="lock"
                    @keyup.enter="validateBeforeSubmit(submit)"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-btn
                  large
                  color="primary"
                  block
                  outline
                  flat
                  :loading="loginLoading"
                  :disabled="loginLoading"
                  @click="validateBeforeSubmit(submit)"
                  >Login</v-btn>
                </v-flex>
              </v-layout>
            </form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import { mapActions } from 'vuex'
import qs from 'qs'

export default {
  data: () => ({
    username: '',
    password: '',
    loginLoading: false
  }),
  methods: {
    submit () {
      this.loginLoading = true
      const loginData = {
        username: this.username,
        password: this.password,
        grant_type: 'password',
        client_id: 'ai.client',
        client_secret: 'secret'
      }

      const queryString = qs.stringify(loginData)

      this.$auth
        .login({
          // eslint-disable-next-line no-undef
          url: `${new URL('connect/token', config ? config.VUE_APP_IDENTITY_SERVER_URI || process.env.VUE_APP_IDENTITY_SERVER_URI : process.env.VUE_APP_IDENTITY_SERVER_URI).href}`,
          data: queryString, // Axios
          redirect: { name: 'home' }, // Redirect to correct page
          fetchUser: true
        })
        .then(() => {
          this.$store.dispatch('configurations/getConfigurations')
          this.loginLoading = false
        }, (error) => {
          this.handleAxiosError(error)
          this.loginLoading = false
        })
    },
    ...mapActions({
      setSnack: 'snackbar/setSnack'
    })
  }
}
</script>
